import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API from '../../config/axiosConfig';
import { UserContext } from '../../context/UserContext';
import CommonLayout from '../../components/CommonLayout';
import Loader from '../../components/Loader';
import PageTitle from '../../components/PageTitle';
import { Button } from '@mui/material';
import DynamicFaIcon from '../../components/DynamicFaIcon';
import DeleteConfirmationDialog from '../../components/dialogs/DeleteConfirmationDialog';
import './AppsMgmt.scss';

function AppsMgmt() {
  const [apps, setApps] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [appToDelete, setAppToDelete] = useState(null);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchApps();
  }, []);

  const fetchApps = async () => {
    setIsLoading(true);
    try {
      const response = await API.get('/api/apps');
      setApps(response.data);
    } catch (error) {
      console.error('Fetching apps failed:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB');
   };

  const handleDeleteClick = (app) => {
   setAppToDelete(app);
   setIsDeleteDialogOpen(true);
  };

  const statusMap = {
   inDevelopment: 'בפיתוח',
   new: 'חדש',
  };

  const handleConfirmDelete = async () => {
   if (!appToDelete) return;
   try {
     await API.delete(`/api/apps/${appToDelete._id}`);
     setApps(apps.filter((app) => app._id !== appToDelete._id));
     setIsDeleteDialogOpen(false);
     setAppToDelete(null);
   } catch (error) {
     console.error('Deleting app failed:', error);
   }
  };

  if (!user || !user.isSuperAdmin) {
    return (
      <CommonLayout>
        <div className="apps-mgmt-container" style={{ direction: 'rtl' }}>
          <p>אין לך הרשאה לצפות בדף זה.</p>
        </div>
      </CommonLayout>
    );
  }

  return (
    <CommonLayout>
      <div className="apps-mgmt-container" style={{ direction: 'rtl' }}>
        <PageTitle title="ניהול אפליקציות" />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/apps-mgmt/add')}
          style={{ backgroundColor: '#103C6E' }}
        >
          הוסף אפליקציה חדשה
        </Button>
        <div className="apps-list">
          {apps.map((app) => (
            <div key={app._id} className={`app-card status-${app.status}`}>
               {app.status !== 'normal' && <div className="status-strip">{statusMap[app.status]}</div>}
              <div className="app-card-header">
                <DynamicFaIcon iconName={app.icon} />
                <h2>{app.title}</h2>
              </div>
              <div className="app-card-body">
                <p><strong>מפתח:</strong> {app.key}</p>
                <p><strong>קרדיט:</strong> {app.credit}</p>
                <p><strong>עודכן על ידי:</strong> {app.lastUpdatedBy?.name || 'N/A'}</p>
                <p><strong>עודכן לאחרונה:</strong> {formatDate(app.lastUpdatedAt)}</p>
              </div>
              <div className="app-card-actions">
                <Button
                  variant="outlined"
                  onClick={() => navigate(`/apps-mgmt/edit/${app._id}`)}
                  style={{ color: '#103C6E', borderColor: '#103C6E' }}
                 >
                   ערוך
                 </Button>
                 <Button
                    variant="outlined"
                    onClick={() => handleDeleteClick(app)}
                    style={{ color: '#ff4d4f', borderColor: '#ff4d4f' }}
                    >
                    מחק
                 </Button>
                 <a href={`https://my.mashlom.me/main/apps/${app.appToken}`} target="_blank" rel="noopener noreferrer" className="app-link">
                    לאפליקציה &larr;
                </a>

              </div>
            </div>
          ))}
        </div>
        <Loader isLoading={isLoading} />
        <DeleteConfirmationDialog
          open={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
          onConfirm={handleConfirmDelete}
          title={`האם אתה בטוח שברצונך למחוק את האפליקציה "${appToDelete?.title}"?`}
        />
      </div>
    </CommonLayout>
  );
}

export default AppsMgmt;